import { useState, useMemo } from "react"
import dayjs from "dayjs"

/**
 * Custom hook for managing date picker state and logic
 * @param {dayjs} initialDate - Initial selected date (default: today)
 * @returns {Object} Date picker state and handlers
 */
export const useDatePicker = (initialDate = dayjs()) => {
  const [selectedDate, setSelectedDate] = useState(initialDate)
  const [pendingDate, setPendingDate] = useState(null)
  const [datePickerOpen, setDatePickerOpen] = useState(false)

  // Calculate date picker value for display
  const datePickerValue = useMemo(() => {
    if (datePickerOpen) {
      if (pendingDate) {
        return [pendingDate, pendingDate]
      }
      return [selectedDate, null]
    }
    return [selectedDate, selectedDate]
  }, [datePickerOpen, pendingDate, selectedDate])

  const handleOpenChange = (open) => {
    setPendingDate(null)
    setDatePickerOpen(open)
  }

  const handleCalendarChange = (vals) => {
    const picked = vals?.findLast(Boolean)
    if (picked) setPendingDate(picked)
  }

  const handleChange = (vals) => {
    const picked = vals?.findLast(Boolean)
    if (picked) setPendingDate(picked)
  }

  const handleDone = () => {
    if (pendingDate) {
      setSelectedDate(pendingDate)
    }
    setDatePickerOpen(false)
    setPendingDate(null)
  }

  const handleToggle = () => {
    setDatePickerOpen(!datePickerOpen)
  }

  const currentDisplayDate = pendingDate || selectedDate

  return {
    selectedDate,
    pendingDate,
    datePickerOpen,
    datePickerValue,
    currentDisplayDate,
    handleOpenChange,
    handleCalendarChange,
    handleChange,
    handleDone,
    handleToggle
  }
}
